module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "pages-content"
  }, [_c('Header'), _c('div', {
    staticClass: "main_content"
  }, [_c('div', {
    staticClass: "heroslider"
  }, [(_vm.props.acf.perfect_hero_banner_img) ? _c('div', {
    staticClass: "heroslide",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.perfect_hero_banner_img + ')'
    })
  }, [_c('div', {
    staticClass: "herooverlay"
  })]) : _vm._e(), _c('div', {
    staticClass: "heroslidecaptions perfecttreatment"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "herotitle"
  }, [(_vm.props.acf.perfect_hero_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.perfect_hero_title)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "hero_subtitle"
  }, [(_vm.props.acf.perfect_hero_subtitle) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.perfect_hero_subtitle)
    }
  }) : _vm._e()])])])]), _c('div', {
    staticClass: "perfect_treatment"
  }, [(_vm.props.acf.perfect_treatment_list) ? _c('div', {
    staticClass: "perfect_treatmentwrap"
  }, _vm._l((_vm.props.acf.perfect_treatment_list), function(PerfectList, index) {
    return _c('div', {
      staticClass: "perfect_treatmentlist",
      attrs: {
        "id": 'perfectlist' + index
      }
    }, [_c('h2', {
      staticClass: "perfectmaintitle",
      domProps: {
        "innerHTML": _vm._s(PerfectList.title)
      }
    }), _c('div', {
      staticClass: "treatinner"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 col-sm-6 treatborder"
    }, [_c('div', {
      staticClass: "contenttreat1",
      domProps: {
        "innerHTML": _vm._s(PerfectList.left_content)
      }
    }), (PerfectList.accordion_treat) ? _c('div', {
      staticClass: "accordion_perfect"
    }, [_c('div', {
      staticClass: "accordion accordionmanual",
      attrs: {
        "role": "tablist"
      }
    }, _vm._l((PerfectList.accordion_treat), function(PerfectAccorList, id) {
      return _c('b-card', {
        staticClass: "mb-1",
        attrs: {
          "no-body": ""
        }
      }, [_c('b-card-header', {
        staticClass: "p-1",
        attrs: {
          "header-tag": "headerr",
          "role": "tab"
        }
      }, [_c('div', {
        directives: [{
          name: "b-toggle",
          rawName: "v-b-toggle",
          value: ('accordionperfect' + id),
          expression: "'accordionperfect' + id"
        }],
        staticClass: "btnaccordion",
        attrs: {
          "block": "",
          "variant": "info"
        }
      }, [(PerfectAccorList.title) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(PerfectAccorList.title)
        }
      }) : _vm._e()])]), _c('b-collapse', {
        attrs: {
          "accordion": "my-accordion",
          "role": "tabpanel",
          "id": 'accordionperfect' + id
        }
      }, [_c('b-card-body', [(PerfectAccorList.content) ? _c('span', {
        staticClass: "b-card-text",
        domProps: {
          "innerHTML": _vm._s(PerfectAccorList.content)
        }
      }) : _vm._e()])], 1)], 1)
    }))]) : _vm._e()]), _c('div', {
      staticClass: "col-md-6 col-sm-6 treatborder",
      domProps: {
        "innerHTML": _vm._s(PerfectList.heading_content)
      }
    })])])])
  })) : _vm._e()])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ef29444","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/your-perfect-treatment/your-perfect-treatment.pug
// module id = 820
// module chunks = 1